<template>
    <div class="menu-second">
        <div class="menu-second">
            <div class="menu-title">
                <span>分销</span>
            </div>
            <div class="menu-list">
                <div class="menu-item">
                    <router-link class="menu-item_title" :to="{path: '/app/dealer/apply.html'}">入驻审核</router-link>
                </div>
                <div class="menu-item">
                    <router-link class="menu-item_title" :to="{path: '/app/dealer/user.html'}">分销商</router-link>
                </div>
                <div class="menu-item">
                    <router-link class="menu-item_title" :to="{path: '/app/dealer/goods.html'}">分销商品</router-link>
                </div>
                <div class="menu-item">
                    <router-link class="menu-item_title" :to="{path: '/app/dealer/order.html'}">分销订单</router-link>
                </div>
                <div class="menu-item">
                    <router-link class="menu-item_title" :to="{path: '/app/dealer/withdraw.html'}">提现管理</router-link>
                </div>
                <div class="menu-item">
                    <router-link class="menu-item_title" :to="{path: '/app/dealer/level.html'}">分销等级</router-link>
                </div>
                <div class="menu-item">
                    <router-link class="menu-item_title" :to="{path: '/app/dealer/setting.html'}">分销设置</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "left"
    }
</script>

<style scoped>

</style>
